import Mock from 'mockjs'

Mock.mock('/api/login', 'post', (options) => {
  const { username, password } = JSON.parse(options.body)
  if (username === 'admin' && password === '123456') {
    return { code: 200, token: 'ADMIN-TOKEN' }
  }
  return { code: 400, msg: '账号密码错误' }
})

Mock.mock('/api/user/list', 'get', {
  code: 200,
  data: [
    { id: 1, name: '张三', status: 1 },
    { id: 2, name: '李四', status: 0 }
  ]
})

Mock.mock('/api/goods/list', 'get', {
  code: 200,
  data: [
    { id: 1, name: 'iPhone 15', price: 5999, stock: 100 },
    { id: 2, name: '小米14', price: 3999, stock: 200 }
  ]
})

Mock.mock('/api/order/list', 'get', {
  code: 200,
  data: [
    { id: 1, no: 'DD2025001', money: 5999, status: '待发货' },
    { id: 2, no: 'DD2025002', money: 3999, status: '已完成' }
  ]
})